// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_j6-0";
export var optionCard = "_j6-1";